// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPeopleLink__link-f6917a {
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 8px 16px;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
}

.AddPeopleLink__link-f6917a:hover,
.AddPeopleLink__link-f6917a:focus {
  background: var(--addition-50_05);
}

.AddPeopleLink__link-f6917a:active {
  background: var(--addition-50_10);
}

.AddPeopleLink__icon-e6f088 {
  fill: var(--addition-50);
  padding: 12px;
  background: var(--addition-50_10);
  border-radius: 50%;
  margin-inline-end: 16px;
}

.AddPeopleLink__title-b26e89 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/GroupAudioCall/AddPeopleLink/AddPeopleLink.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;;EAEE,iCAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,wBAAA;EACA,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF","sourcesContent":[".link {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  padding: 8px 16px;\n  width: 100%;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.link:hover,\n.link:focus {\n  background: var(--addition-50_05);\n}\n\n.link:active {\n  background: var(--addition-50_10);\n}\n\n.icon {\n  fill: var(--addition-50);\n  padding: 12px;\n  background: var(--addition-50_10);\n  border-radius: 50%;\n  margin-inline-end: 16px;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `AddPeopleLink__link-f6917a`,
	"icon": `AddPeopleLink__icon-e6f088`,
	"title": `AddPeopleLink__title-b26e89`
};
module.exports = ___CSS_LOADER_EXPORT___;
